export enum VerificationMedium {
  Email  = 'email',
  Mobile = 'sms',
  IVR    = 'ivr'
}

const Mediums = Object.keys(VerificationMedium).map(k => VerificationMedium[k]);


export const getTranslationKeyByVerificationMediumString = (medium?: string) => {
  if (!medium) {
    medium = 'CONFIGURED_VERIFICATION_MEDIUM';
  }
  return `PASSWORD_FORGOT_INIT.COMMUNICATION_MEDIUM.${medium.toUpperCase()}`;
};

